import React from 'react'
import {Link, NavLink} from 'react-router-dom';
import './home.css'

class HomeArticle extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.logged) {
            return (
                <div className="home-article">
                    <img className="home-title" src={require("../assert/CampusForm.png")} alt="CampusForm"></img>
                    <Link to="questionCreate"><img className="home-question" src={require("../assert/question.png")} alt="question"></img></Link>
                    <Link to="voteCreate"><img className="home-vote" src={require("../assert/vote.png")} alt="vote"></img></Link>
                    <Link to="examCreate"><img className="home-exam" src={require("../assert/exam.png")} alt="exam"></img></Link>
                </div>
            );
        }
        else {
            return (
                <div className="home-article">
                    <img className="home-title" src={require("../assert/CampusForm.png")} alt="CampusForm"></img>
                    <Link to="teacherLogin"><img className="home-question" src={require("../assert/question.png")} alt="question"></img></Link>
                    <Link to="teacherLogin"><img className="home-vote" src={require("../assert/vote.png")} alt="vote"></img></Link>
                    <Link to="teacherLogin"><img className="home-exam" src={require("../assert/exam.png")} alt="exam"></img></Link>
                </div>
            );
        }
        
    }
}

export default HomeArticle;